import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { TokenService } from './core/services/tokenservice/token.service';
import { NavService } from './core/services/nav/nav.service';
import { routerTransition } from './shared/animations/route-animations'; // sua animação importada

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [routerTransition]
})
export class AppComponent implements OnInit, OnDestroy {
  navTitle$ = this.navService.title$;
  showNav = true;
  footerClass = 'footer-home';

  private navSubs = new Subscription();
  private tokenSub!: Subscription;

  private routeOrder: string[] = ['home', 'auth', 'manage-profile', 'permission-management', 'unauthorized'];
  private currentRouteIndex = 0;
  animationState: 'forward' | 'backward' = 'forward';

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private tokenService: TokenService,
    private navService: NavService
  ) {
    this.addGoogleTagManagerNoscript();
  }

  ngOnInit() {
    this.navSubs.add(this.navService.showNav$.subscribe(show => this.showNav = show));

    this.navSubs.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((nav) => {
          const path = nav.urlAfterRedirects.split('?')[0].split('#')[0].replace('/', '') || 'home';

          // Atualiza visibilidade da nav
          const isHome = path === 'home';
          this.navService.setShowNav(!isHome);

          // Atualiza estilo do footer
          this.updateFooterClass(nav.urlAfterRedirects);

          // Detecta direção da navegação
          const newIndex = this.routeOrder.indexOf(path);
          if (newIndex > this.currentRouteIndex) {
            this.animationState = 'forward';
          } else if (newIndex < this.currentRouteIndex) {
            this.animationState = 'backward';
          }
          this.currentRouteIndex = newIndex;
        })
    );

    this.tokenSub = this.tokenService.token$.subscribe(() => {
      this.updateFooterClass(this.router.url);
    });
  }

  ngOnDestroy() {
    this.tokenSub?.unsubscribe();
    this.navSubs.unsubscribe();
  }

  updateFooterClass(url: string) {
    this.footerClass = url === '/home' ? 'footer-home'
      : !!this.tokenService.getToken()
        ? 'footer-logados' : 'footer-home';
  }

  private addGoogleTagManagerNoscript(): void {
    const noscript = this.renderer.createElement('noscript');
    const iframe = this.renderer.createElement('iframe');

    this.renderer.setAttribute(
      iframe,
      'src',
      'https://www.googletagmanager.com/ns.html?id=GTM-NBBGG9DZ'
    );
    this.renderer.setAttribute(iframe, 'height', '0');
    this.renderer.setAttribute(iframe, 'width', '0');
    this.renderer.setStyle(iframe, 'display', 'none');
    this.renderer.setStyle(iframe, 'visibility', 'hidden');

    this.renderer.appendChild(noscript, iframe);
    this.renderer.appendChild(document.body, noscript);
  }

  getState(outlet: RouterOutlet) {
    return this.animationState;
  }
}
